import 'formdata-polyfill';
import h from 'hyperscript';
import * as is from 'utilities/is';
import { now } from 'utilities/time';
import { inHapYakTools } from 'utilities/context';

export const LOCATOR_PREFIX = 'locator://';

export const loadJS = src => {
    return new Promise((resolve, reject) => {
        const scriptTag = document.createElement('script');

        scriptTag.src = src;
        scriptTag.onload = resolve;
        scriptTag.onerror = reject;
        document.head.appendChild(scriptTag);
    });
};

export const loadCss = src => {
    return new Promise((resolve, reject) => {
        const tag = document.createElement('link');
        tag.rel = "stylesheet";
        tag.href = src;
        tag.onload = resolve;
        tag.onerror = reject;
        document.head.appendChild(tag);
    });
};

export const download = url => {
    const el = <a download target="_blank" href={ url }></a>;
    el.click();
};

export const toDataURL = (value, mime) => {
    const b = new Blob([value], mime),
        url = URL.createObjectURL(b);

    return url;
};

export const sendBeacon = (url, data = {}) => {
    const payload = new FormData();

    Object.keys(data).forEach(k => payload.append(k, data[k]));

    return fetch(url, {
        method: 'POST',
        body: payload,
        mode: 'no-cors',
        credentials: 'include',
        keepalive: true
    });
};

export const submitForm = (url, body, method = 'POST', config = {}) => {
    let args = { method, ...config };

    if (method === 'GET') {
        url = `${url}?${new URLSearchParams(body.entries())}`;
    } else {
        args.body = body;
    }
    
    return fetch(url, args).then(res => res.json());
};

export const parseLocator = (src = '', endpoint = LOCATOR_ENDPOINT) => {
    if (src.startsWith(LOCATOR_PREFIX)) {
        const cacheBust = inHapYakTools() ? `&ts=${now()}` : '';
        endpoint = endpoint.includes('?') ? `${endpoint}&` : `${endpoint}?`;

        return (
            fetch(`${endpoint}locator=${encodeURIComponent(src.replace(LOCATOR_PREFIX, ''))}${cacheBust}`)
                .then(res => res.json())
                .then(json => json.location)
        );
    }

    return Promise.resolve(src);
}

export const fetchHistory = new (class {
    constructor() {
        this.requests = {};
    }

    addPending = url => this.requests[url] = 'pending'
    setComplete = url => this.requests[url] = 'complete'
    setFailed = url => this.request[url] = 'failed'

    get pending() {
        return Object.values(this.requests).filter(r => r === 'pending');
    }
})();

export const trackableFetch = (req, opts = {}) => {
    fetchHistory.addPending(req);

    return (
        fetch(req, opts)
            .then(res => {
                fetchHistory.setComplete(req);
                return res;
            })
            .catch(() => {
                fetchHistory.setFailed(req);
            })
    )
}